import React from "react";
import { Modal } from "react-bootstrap";
import { formatNumber } from "../../../utils/convertToNumber";

const STCreditModal = ({ show, setOpen, STCredit }) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-right"
    >
      <Modal.Body>
        <div className="p-6 mx-auto w-full max-w-3xl bg-white rounded-lg">
          <h5 className="mb-6 text-3xl font-semibold text-center text-gray-800">
            Short Term Credit List
          </h5>

          <div className="space-y-4">
            {STCredit?.map((credit, index) => (
              <div
                className="flex items-center p-4 bg-gray-50 rounded-lg shadow-sm transition duration-200 hover:bg-gray-100"
                key={credit._id}
              >
                <span className="mr-4 text-sm font-medium text-gray-600">
                  {index + 1}.
                </span>
                <label
                  htmlFor={`company-list-${credit._id}`}
                  className="flex justify-between w-full cursor-pointer"
                >
                  <span className="text-base font-medium text-gray-800">
                    {credit._id}
                  </span>
                  <span className="text-base font-medium text-gray-800">
                    {formatNumber(credit?.total?.toFixed(2))} ETB
                  </span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex gap-4 justify-end w-full">
          <button
            type="button"
            className="px-5 py-2 text-gray-700 bg-gray-200 rounded-md transition duration-200 hover:bg-gray-300"
            onClick={handleClose}
          >
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default STCreditModal;
